export enum BackgroundViewType {
  Streets = 'streets',
  Ign = 'ign',
  Satellite = 'satellite',
  SatelliteStreet = 'satellite-street',
  Dark = 'dark',
}
